<div class="main-wrapper">
	<!-- Loading Screen -->
	<div *ngIf="app.isLoading && app?.isPlatformBrowserVar" class="d-flex justify-content-center">
		<!-- <div class="layout"></div> -->
		<!-- <div class="spinner-border spinnerAtr text-white" role="status">
			<span class="sr-only spinnerCrt">Loading...</span>
		</div> -->
		<img [ngClass]="this.app?.getUserLanguage() == 'en' ? 'rl' : 'lr'" class="imgLoading" src="./assets/img/Heart-1s-200px.gif" alt="loading" />
	</div>

	<!-- <img *ngIf="loading" src="/assets/loading.gif" alt="loading" />
	<img [hidden]="loading" (load)="onLoad()" src="{{ source }}" /> -->

	<!-- Box Notification For Video Call -->
	<app-upcoming-visits-box *ngIf="app?.isPlatformBrowserVar" class="app-box" [Visits]="upComingVisits$"></app-upcoming-visits-box>

	<app-headerboot *ngIf="app?.isPlatformBrowserVar"></app-headerboot>

	<main>
		<router-outlet></router-outlet>
	</main>

	<app-footer *ngIf="app?.isPlatformBrowserVar"></app-footer>
</div>